import { useMemo } from 'react';
import { ProjectListItemContainer } from 'shared/_model/project/project-list/project-list-item/styles';
import { DocType } from 'shared/constants/docs';
import { r } from 'shared/constants/routes';
import { FieldTagField } from 'shared/_ui/form/form-tag-field';
import ProjectFileCountIcon from 'shared/_model/project-details/ProjectFileCountIcon';
import { ShareSettingsIcon } from 'shared/components/ShareSettingsButton';
import { SharingType } from 'shared/_model/sharing/types';
import CopyToClipboardValue from 'shared/_components/copy-to-clipboard-value';
import ListItemCreated from 'shared/_components/list/list-item-created';
import {
	listItemIdProps,
	ListItemBox,
	ListItemBoxDnLg,
	ListItemBoxDnMd,
	ListItemBoxIcons,
	ListItemBoxUpLg,
	ListItemBoxUpMd,
	ListItemText,
	ListItemTitleLink,
} from 'shared/_components/list/styles';
import { getProjectFileCount } from 'shared/_model/project/project-list/project-list-item/utils';
import { ProjectListItemElement } from 'shared/_model/project/project-list/store';

type ProjectListItemProps = ProjectListItemElement;

export default function ProjectListItem(props: ProjectListItemProps) {
	const { _id, title, created, sharing, tags } = props;

	const fileInfo = useMemo(() => {
		const finishedVideo = getProjectFileCount(props, DocType.FILE_FINISH_VIDEO);
		const finishedAudio = getProjectFileCount(props, DocType.FILE_FINISH_AUDIO);
		return {
			finishedVideo,
			finishedAudio,
			infoText: `Finished videos: ${finishedVideo} | Finished audio: ${finishedAudio}`,
		};
	}, [props]);

	// TODO: Remove this example when implement it on other list page
	// const image = useMemo(() => {
	// 	return getItemPreview(type, props);
	// }, [props]);
	// const image = {
	// 	"s3": {
	// 		"key": "u0dj3a/PRJu0dj3aqDUqc0D/file-project/IMG_4004_FPRu0dj3alRZWJqe.MP4_thumbnail.jpeg",
	// 		"uploaded": "2025-03-01T16:32:51.071Z"
	// 	}
	// };

	return (
		<ProjectListItemContainer>
			<ListItemTitleLink href={r.project({ projectId: _id })}>{title}</ListItemTitleLink>
			<ListItemBox gridArea="info">
				<ListItemCreated value={created} hideOnMobile />
				<ListItemText>{fileInfo.infoText}</ListItemText>
				{!!tags?.length && (
					<ListItemBoxDnLg>
						<FieldTagField name="tags" value={tags} fullWidth />
					</ListItemBoxDnLg>
				)}
				<ListItemBoxDnMd>
					<CopyToClipboardValue value={_id} {...listItemIdProps} />
				</ListItemBoxDnMd>
			</ListItemBox>
			<ListItemBoxUpLg gridArea="tags" sx={{ alignSelf: 'normal', mt: '-2px' }}>
				<FieldTagField name="tags" value={tags} fullWidth />
			</ListItemBoxUpLg>
			<ListItemBoxUpMd gridArea="id">
				<CopyToClipboardValue value={_id} {...listItemIdProps} />
			</ListItemBoxUpMd>
			<ListItemBoxIcons>
				<ProjectFileCountIcon type={DocType.FILE_FINISH_VIDEO} count={fileInfo.finishedVideo} />
				<ProjectFileCountIcon type={DocType.FILE_FINISH_AUDIO} count={fileInfo.finishedAudio} />
				<ShareSettingsIcon sharing={sharing} type={SharingType.PROJECT} />
			</ListItemBoxIcons>
		</ProjectListItemContainer>
	);
}
